import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const InfoIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.823 17.38V9.617h2.354v7.761zm0-9.087V6.207h2.354v2.086z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
